import React from "react";

import { FavoriteProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/FavoriteProps";
import { useGetProductTileClickImpressions } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";

import { FavoriteTrackingEventsContext } from "./FavoriteTrackingEventsContext";

export const FavoriteTrackingEventsContextProviderBase = ({
  children,
  data: { productToken, impressionId, promotedBy },
  customEvents,
}: {
  children: React.ReactNode;
  data: FavoriteProps;
  customEvents?: {
    recordHeartClickedEvent?: () => void;
    recordSaveToBoardSubmitEvent?: (boardToken?: string) => void;
    recordRemoveFromBoardSubmitEvent?: (boardToken?: string) => void;
  };
}) => {
  const {
    recordHeartClickedEvent,
    recordSaveToBoardSubmitEvent,
    recordRemoveFromBoardSubmitEvent,
  } = useGetProductTileClickImpressions({
    token: productToken,
    impressionId,
    promotedBy,
  });

  const onHeartClicked = () => {
    customEvents?.recordHeartClickedEvent?.();
    recordHeartClickedEvent();
  };
  const onSaveToBoardSubmit = (boardToken?: string) => {
    customEvents?.recordSaveToBoardSubmitEvent?.(boardToken);
    recordSaveToBoardSubmitEvent(boardToken);
  };
  const onRemoveFromBoardSubmit = (boardToken?: string) => {
    customEvents?.recordRemoveFromBoardSubmitEvent?.(boardToken);
    recordRemoveFromBoardSubmitEvent(boardToken);
  };
  return (
    <FavoriteTrackingEventsContext.Provider
      value={{
        recordHeartClickedEvent: onHeartClicked,
        recordSaveToBoardSubmitEvent: onSaveToBoardSubmit,
        recordRemoveFromBoardSubmitEvent: onRemoveFromBoardSubmit,
      }}
    >
      {children}
    </FavoriteTrackingEventsContext.Provider>
  );
};
